// extracted by mini-css-extract-plugin
var _1 = "button__NSEII";
var _2 = "button--big__p2gEx";
var _3 = "button--disabled__A4O3d";
var _4 = "button--only-icon__IQy0w";
var _5 = "button--primary__du8Cn";
var _6 = "button--quaternary__qSIur";
var _7 = "button--secondary__aMpEA";
var _8 = "button--small__AWktR";
var _9 = "button--tertiary__II7Fn";
var _a = "button--warning__o6Lfs";
var _b = "iconBefore__SXZFB";
export { _1 as "button", _2 as "button--big", _3 as "button--disabled", _4 as "button--only-icon", _5 as "button--primary", _6 as "button--quaternary", _7 as "button--secondary", _8 as "button--small", _9 as "button--tertiary", _a as "button--warning", _b as "iconBefore" }
